module.exports = __webpack_public_path__ + "img/share_word_.384805ab.png";